import React, { useContext, useState } from 'react'
import { motion } from 'framer-motion'
import { PokemonContext} from '../Context/PokemonContext'

function Dropdown() {
    const [showFilter, setShowFilter] = useState(false)

    const l_line = {
      open: { width: '12px', opacity: 1},
      closed: { width: '12px', opacity: 1, rotate: '-45deg',  translateY: '5px'},
    }
    const m_line = {
      open: { width: '8px', opacity: 1},
      closed: { width: '12px', opacity: 0, },
    }

    const s_line = {
      closed: { width: '12px', rotate: '45deg', translateY: '-5px'},
      open: { width: '4px', left: 0, opacity: 1},
    }

  return (
    <div className='relative'>
        <div onClick={() => setShowFilter((prev) => !prev)} className={`w-[32px] flex flex-col items-center justify-center h-[32px] rounded-full bg-white
        ${showFilter ?  'shadow-[0px_1px_3px_1px_#00000040]' : "shadow-[inset_0px_1px_3px_1px_#00000040]"}`}
         >
          <div className='flex flex-col items-start gap-y-1'>

          <motion.svg
          animate={showFilter ? "closed" : "open"}
          variants={l_line}
          transition={{ duration: 0.2, ease: "easeIn", }}
           width="12" height="1" viewBox="0 0 12 1" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="12" height="1" rx="0.5" fill="#DC0A2D"/>
          </motion.svg>
          <motion.svg
          animate={showFilter ? "closed" : "open"}
          variants={m_line}
          transition={{ duration: 0.2, ease: "easeIn", }}
           width="12" height="1" viewBox="0 0 12 1" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="12" height="1" rx="0.5" fill="#DC0A2D"/>
          </motion.svg>
          <motion.svg
          animate={showFilter ? "closed" : "open"}
          variants={s_line}
          transition={{ duration: 0.2, ease: "easeIn", }}
           width="12" height="1" viewBox="0 0 12 1" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="12" height="1" rx="0.5" fill="#DC0A2D"/>
          </motion.svg>



          </div>
            {/* <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 8H0.5C0.355556 8 0.236111 7.95278 0.141667 7.85833C0.0472223 7.76389 0 7.64444 0 7.5C0 7.35556 0.0472223 7.23611 0.141667 7.14167C0.236111 7.04722 0.355556 7 0.5 7H3.5C3.64444 7 3.76389 7.04722 3.85833 7.14167C3.95278 7.23611 4 7.35556 4 7.5C4 7.64444 3.95278 7.76389 3.85833 7.85833C3.76389 7.95278 3.64444 8 3.5 8ZM11.5 1H0.5C0.355556 1 0.236111 0.952778 0.141667 0.858333C0.0472223 0.763889 0 0.644444 0 0.5C0 0.355556 0.0472223 0.236111 0.141667 0.141667C0.236111 0.0472223 0.355556 0 0.5 0H11.5C11.6444 0 11.7639 0.0472223 11.8583 0.141667C11.9528 0.236111 12 0.355556 12 0.5C12 0.644444 11.9528 0.763889 11.8583 0.858333C11.7639 0.952778 11.6444 1 11.5 1ZM7.5 4.5H0.5C0.355556 4.5 0.236111 4.45278 0.141667 4.35833C0.0472223 4.26389 0 4.14444 0 4C0 3.85556 0.0472223 3.73611 0.141667 3.64167C0.236111 3.54722 0.355556 3.5 0.5 3.5H7.5C7.64444 3.5 7.76389 3.54722 7.85833 3.64167C7.95278 3.73611 8 3.85556 8 4C8 4.14444 7.95278 4.26389 7.85833 4.35833C7.76389 4.45278 7.64444 4.5 7.5 4.5Z" fill="#DC0A2D"/>
            </svg> */}
        </div>
        <DropdownOptions showFilter={showFilter}/>
    </div>
  )
}

function DropdownOptions({showFilter}) {
    const [filter, setFilter] = useState(null)
    const {pokemonList, setPokemonList} = useContext(PokemonContext)

    const variants = {
      open: { right: '-38.5%', opacity: 1},
      closed: { right: '-350%', opacity: 0},
    }

    const handleSortByName = () => {
      setPokemonList(pokemonList.slice().sort((a, b) => a.name.localeCompare(b.name)));
    }

    const handleSortByNumber = () => {
      setPokemonList(pokemonList.slice().sort((a, b) => a.id - b.id ));
    }

    return (

        <motion.div
        animate={showFilter ? "open" : "closed"}
        variants={variants}
        transition={{ duration: 0.4, ease: "linear", }}
         className='w-[114px] absolute opacity-0  right-[-38%] z-50 mt-[15px] bg-primary h-[132px] rounded-[12px] flex flex-col items-start pt-[18px] px-1'>
            <p className='text-white pl-4 text-[12px] font-bold'>Sort By:</p>
            <div className='bg-white w-full h-[80px] shadow-[inset_0px_1px_3px_1px_#00000040] mt-[10px] rounded-[8px] px-[20px] py-[16px]'>
                <div className='flex flex-col gap-y-4'>
                <label className='flex items-center space-x-2'>
        <input
        onClick={() => handleSortByNumber()}
          type="radio"
          name="option"
          value="number"
          className='form-radio h-[14px] w-[14px] text-primary border-primary focus:ring-transparent'
        />
        <span className='text-dark font-semibold text-[10px]'>Number</span>
      </label>

      {/* Second Radio Input */}
      <label className='flex items-center space-x-2'>
        <input
        onClick={() => handleSortByName()}
          type="radio"
          name="option"
          value="name"
          className='form-radio h-[14px] w-[14px] text-primary border-primary focus:ring-transparent'
        />
        <span className='text-dark font-semibold text-[10px]'>Name</span>
      </label>
                </div>
            </div>
        </motion.div> 
    )
}

export default Dropdown